<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default { }
    let ui = JSON.parse(localStorage.getItem('ms_uinfo'));
    let homeName = '系统首页';
    window.$gloable = {
        userinfo: {
            sign: localStorage.getItem('ms_usign'),
            obj: ui
        },
        tags: {
            homeName: homeName,
            tagsList: [{
                name: 'home',
                path: '/home',
                title: homeName,
                lock: true
            }]
        },
    };
</script>

<style>
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";
</style>

<style>
    .el-tree-node.is-current>.el-tree-node__content {
        background-color: #c2d6ea !important;
    }
</style>
